import React from "react";
import { Link } from "react-router-dom";

const InnerContactInfo = () => {
  const info_items = [
    {
      src: "/img/icon/loction_icon03.png",
      title: "Address",
      desc: (
        <>
          <p>1001 S. Main St. STE 500 Kalispell, MT 59901</p>
        </>
      ),
    },
    {
      src: "/img/icon/mail_icon03.png",
      title: "Email",
      desc: (
        <>
          <Link to="mailto:info@thedigitalcreativedesigns.com">info@thedigitalcreativedesigns.com</Link>
        </>
      ),
    },
    {
      src: "/img/icon/phone_icon03.png",
      title: "Call Us",
      desc: (
        <>
        <span className="" style={{display: "flex"}}>
          <a href="tel:14062251473">14062251473</a>
          
          </span>
        </>
      ),
    },
  ];

  return (
    <ul className="list-wrap">
      {info_items.map((x, index) => (
        <li key={index}>
          <div className="contact-info-item">
            <div className="icon">
              <img src={x.src} alt="" />
            </div>
            <div className="content">
              <h6 className="title">{x.title}</h6>
              {x.desc}
            </div>
          </div>
        </li>
      ))}
    </ul>
  );
};

export default InnerContactInfo;
